module.exports = __webpack_public_path__ + "img/u2417.8ea9dc8a.svg";